module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAbElEQVRYw2NgGAWjYBQMBVBcXPyfHDzqgOHjgFEwmgZGHTAKgMF5nowoOE9NBwiQ6AiQWgFqh4ICEL8nwnKQGgNaRYUBEY4woHV6cMBjeQK9EmUCFssL6J0zCpAsnz9Q2XM+EO8fLahGwZAGAL+voGvVLMj0AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/assets/file-icons/zip.png
// module id = 1623
// module chunks = 0